import angular from 'angular'

import { ProductSuggestions as ProductSuggestionsService } from './product-suggestions.service'
import { srVariantPickerModal } from './variant-picker-modal/VariantPickerModal'
import { ProductEmbeddedBarcodeService } from './product-embedded-barcode.service'

import { VariantPickerModalService } from './variant-picker-modal/variant-picker-modal.service'
import { VariantPickerModalController } from './variant-picker-modal/variant-picker-modal.controller'
import { AddProductFastModalComponent } from './add-product-fast-modal/AddProductFastModal'
import { AddProductFastModalController } from './add-product-fast-modal/add-product-fast-modal.controller'

angular
  .module('webregister.components')
  .component('srVariantPickerModal', srVariantPickerModal)
  .component('addProductFastModal', AddProductFastModalComponent)
  .service('productSuggestions', ProductSuggestionsService)
  .service('productEmbeddedBarcodeService', ProductEmbeddedBarcodeService)
  .service('variantPickerModalService', VariantPickerModalService)
  .controller('variantPickerModalController', VariantPickerModalController)
  .controller('addProductFastModalController', AddProductFastModalController)
